import React, { useState, useEffect, useContext } from "react";
import awsconfig from "../../aws-exports";
import Amplify, { I18n, Auth, API } from "aws-amplify";
import { CognitoIdentityServiceProvider, AWSError } from "aws-sdk";
import CircularProgress from "@material-ui/core/CircularProgress";
import CreateUser from "./CreateUser";
import UserCuration from "./UserCuration";
import Alert from "react-s-alert";
import TextField from "@material-ui/core/TextField";
import { UserContext } from "../../UserContext";
import { cognitoApi } from "../../api";

const Users = (props) => {
  const { activeUser, setActiveUser, userGroups } = useContext(UserContext);

  // console.log(userGroups)

  // const [user, setUser] = useState({})
  const [users, setUsers] = useState([]);

  const [userGroup, setUserGroup] = useState("All Users");

  const [search, setSearch] = useState(false);
  const [firstNameSearch, setFirstNameSearch] = useState("");
  const [lastNameSearch, setLastNameSearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");

  const [groups, setGroups] = useState([]);

  const [page, setPage] = useState("");

  const alertNotification = {
    position: "top-right",
    effect: "flip",
    beep: false,
    timeout: 50000,
    offset: 100,
    color: "rgba(255, 255, 255, 0.927)",
  };

  useEffect(() => {
    getUsers();
    getGroups();
  }, []);

  let filter = "";

  if (firstNameSearch) {
    filter = `given_name ^= \"${firstNameSearch}\"`;
  }
  if (lastNameSearch) {
    filter = `family_name ^= \"${lastNameSearch}\"`;
  }
  if (emailSearch) {
    filter = `email ^= \"${emailSearch}\"`;
  }

  const getUsers = () => {
    // let params = {
    //   UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    //   AttributesToGet: [
    //     'sub',
    //     'email_verified',
    //     'given_name',
    //     'family_name',
    //     'email'
    //   ],
    //   Filter: filter,
    //   Limit: 60
    // }
    cognitoApi
      .getUsers({ filter })
      .then((res) => {
        setUsers(res.data);
        setUserGroup("All Users");
      })
      .catch(console.error);
  };

  // const getUsersPage = () => {
  //   let params = {
  //     UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  //     AttributesToGet: [
  //       'sub',
  //       'email_verified',
  //       'given_name',
  //       'family_name',
  //       'email'
  //     ],
  //     PaginationToken: page,
  //     Limit: 60
  //   }
  //   const cognito = new CognitoIdentityServiceProvider(currentRegion);
  //   return cognito.listUsers(params)
  //     .promise()
  //     .then(res => {
  //       console.log(res)
  //       setUsers(res.Users)
  //       setUserGroup('All Users')
  //       setPage(res.PaginationToken)
  //     })
  //     .catch(console.error);
  // }
  // console.log(users)

  const addUserToGroup = (userName, groupName) => {
    cognitoApi
      .addUserToGroup({ username: userName, group_name: groupName })
      .then((res) => {
        Alert.success(
          `${userName} added to the ${groupName} group`,
          alertNotification
        );
      })
      .catch(console.error);
  };

  const removeUserFromGroup = (userName, groupName) => {
    cognitoApi
      .removeUserFromGroup({ username: userName, group_name: groupName })
      .then((res) => {
        Alert.success(
          `${userName} removed from the ${groupName} group`,
          alertNotification
        );
      })
      .catch(console.error);
  };

  const getGroups = () => {
    cognitoApi.getGroups().then((res) => {
      // setGroups(data.Groups.GroupName)
      // console.log(data.Groups)
      res.data.forEach((group) => {
        groups.push(group.GroupName);
        // console.log(group.GroupName)
      });
    });
  };

  const getUsersInGroups = (
    groupName,
    nextToken = null,
    accumulatedUsers = []
  ) => {
    cognitoApi.listUsersInGroup({ group_name: groupName }).then((res) => {
      setUsers(res.data);
      setUserGroup(groupName);
    });
  };

  const getGroupsByUser = (username) => {
    cognitoApi.getUserGroups({ username }).then((res) => {
      console.log(res);
    });
  };

  const setUserPasswords = () => {
    for (let i = 0; i < users.length; i++) {
      if (users[i].UserStatus === "FORCE_CHANGE_PASSWORD") {
        resetPassword(users[i].Username);
      }
      // console.log(users[i].UserStatus)
    }
  };

  const addUserToSales = () => {
    for (let i = 0; i < users.length; i++) {
      getGroupsByUser(users[i].Username);
    }
  };

  const resetPassword = (username) => {
    cognitoApi
      .resetPassword({ username, password: "IonSolar123!", permanent: false })
      .then((res) => {
        Alert.success(`${username} password reset.`, alertNotification);
        console.log(res);
      });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    getUsers();
  };

  let countUsers = [];

  users.map((user) => {
    if (user.UserStatus === "CONFIRMED") {
      countUsers.push(user);
    }
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "40%",
      }}
    >
      <CreateUser
        addUserToGroup={addUserToGroup}
        getUsers={getUsers}
        userGroups={userGroups}
      />
      {/* <button onClick={() => setUserPasswords()}>Reset Passwords</button>
      <button onClick={() => getUsersPage()}>Next Users</button> */}
      {/* <button onClick={() => addUserToSales()}>add to sales</button> */}
      <div
        style={{
          marginBottom: "1rem",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
          width: "100%",
        }}
      >
        <button
          className={
            userGroup === "Super-Admin" ? "clickedButton button" : "button"
          }
          onClick={() => getUsersInGroups("Super-Admin")}
        >
          Proposals Admin
        </button>
        <button
          className={userGroup === "Admin" ? "clickedButton button" : "button"}
          onClick={() => getUsersInGroups("Admin")}
        >
          Admin
        </button>
        <button
          className={
            userGroup === "Proposals" ? "clickedButton button" : "button"
          }
          onClick={() => getUsersInGroups("Proposals")}
        >
          Proposals
        </button>
        <button
          className={
            userGroup === "Sales-Support" ? "clickedButton button" : "button"
          }
          onClick={() => getUsersInGroups("Sales-Support")}
        >
          Sales Support
        </button>
        <button
          className={userGroup === "Ops" ? "clickedButton button" : "button"}
          onClick={() => getUsersInGroups("Ops")}
        >
          Operations
        </button>
        <button
          className={
            userGroup === "Sales-Rep" ? "clickedButton button" : "button"
          }
          onClick={() => getUsersInGroups("Sales-Rep")}
        >
          Sales Reps
        </button>
      </div>
      <button
        className={
          userGroup === "All Users" ? "clickedButton button" : "button"
        }
        onClick={() => getUsers()}
      >
        All Users
      </button>
      <div>
        <h3>{userGroup}</h3>
      </div>

      {search ? (
        <div>
          <form onSubmit={handleSubmit}>
            <div>
              <TextField
                disabled={lastNameSearch !== "" || emailSearch !== ""}
                type="text"
                className="input"
                variant="filled"
                size="small"
                margin="dense"
                label="First Name"
                value={firstNameSearch}
                onChange={(e) => setFirstNameSearch(e.target.value)}
              ></TextField>
              <TextField
                disabled={firstNameSearch !== "" || emailSearch !== ""}
                type="text"
                className="input"
                variant="filled"
                size="small"
                margin="dense"
                label="Last Name"
                value={lastNameSearch}
                onChange={(e) => setLastNameSearch(e.target.value)}
              ></TextField>
              <TextField
                disabled={lastNameSearch !== "" || firstNameSearch !== ""}
                type="text"
                className="input"
                variant="filled"
                size="small"
                margin="dense"
                label="Email"
                value={emailSearch}
                onChange={(e) => setEmailSearch(e.target.value)}
              ></TextField>
            </div>
            <button type="submit">SEARCH</button>
          </form>
          <div>
            <button
              onClick={() => {
                setSearch(!search);
                setFirstNameSearch("");
                setLastNameSearch("");
                setEmailSearch("");
                getUsers();
              }}
            >
              close
            </button>
            <button
              onClick={() => {
                setFirstNameSearch("");
                setLastNameSearch("");
                setEmailSearch("");
              }}
            >
              clear
            </button>
          </div>
        </div>
      ) : (
        <>
          <button onClick={() => setSearch(!search)}>SEARCH</button>
        </>
      )}

      {users.length > 0 ? (
        <>
          {users.map((user) => {
            return (
              <UserCuration
                getUsersInGroups={getUsersInGroups}
                getUsers={getUsers}
                addUserToGroup={addUserToGroup}
                removeUserFromGroup={removeUserFromGroup}
                userGroup={userGroup}
                userGroups={userGroups}
                key={user.Username}
                user={user}
              />
            );
          })}
        </>
      ) : (
        <div>
          <CircularProgress size={60} color="inherit" />
        </div>
      )}
    </div>
  );
};

export default Users;
